import { create } from 'zustand'

const STORAGE_KEY = 'pc-valores-ocultos'

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false // localStorage indisponível: começa com os valores visíveis
  }
}

interface ValoresOcultosState {
  /** `true` = valores monetários mascarados nas telas (como nos apps de banco). */
  ocultos: boolean
  toggle: () => void
}

export const useValoresOcultosStore = create<ValoresOcultosState>((set, get) => ({
  ocultos: readStored(),
  toggle: () => {
    const ocultos = !get().ocultos
    try {
      localStorage.setItem(STORAGE_KEY, ocultos ? '1' : '0')
    } catch {
      /* preferência só nesta sessão */
    }
    set({ ocultos })
  },
}))
